const REVEAL_THRESHOLD = 0.2;

function revealOnce(selector, requiredSelector = null, triggerSelector = null) {
  const section = document.querySelector(selector);
  if (
    !section
    || section.hidden
    || section.closest("[hidden]")
    || section.classList.contains("is-motion-ready")
    || section.classList.contains("is-visible")
    || (requiredSelector && !section.querySelector(requiredSelector))
  ) {
    return null;
  }

  if (!("IntersectionObserver" in window)) {
    section.classList.add("is-visible");
    return section;
  }

  const trigger = triggerSelector ? section.querySelector(triggerSelector) : section;
  if (!trigger) return null;

  section.classList.add("is-motion-ready");
  const observer = new IntersectionObserver(
    (entries) => {
      if (
        !entries.some(
          (entry) => entry.isIntersecting && entry.intersectionRatio >= REVEAL_THRESHOLD,
        )
      ) {
        return;
      }

      section.classList.add("is-visible");
      observer.unobserve(trigger);
    },
    { threshold: [REVEAL_THRESHOLD] },
  );

  observer.observe(trigger);
  return section;
}

function initPrizeSparkleMotion(section) {
  if (!section) return;

  const sparkles = Array.from(section.querySelectorAll(".prize-sparkle"));
  if (!section.classList.contains("is-motion-ready") || sparkles.length === 0) {
    section.classList.add("is-motion-complete");
    return;
  }

  const trigger = section.querySelector(".prize-stage");
  if (!trigger) {
    section.classList.add("is-motion-complete");
    return;
  }

  const animationDuration = 1000;
  const startViewportRatio = 0.82;
  const endViewportRatio = 0.16;
  let animations = [];
  let frameRequest = 0;

  const updateProgress = () => {
    frameRequest = 0;
    const { top } = trigger.getBoundingClientRect();
    const travel = window.innerHeight * (startViewportRatio - endViewportRatio);
    const progress = Math.min(
      1,
      Math.max(0, (window.innerHeight * startViewportRatio - top) / travel),
    );

    section.classList.toggle("is-motion-complete", progress >= 0.999);

    animations.forEach((animation) => {
      animation.currentTime = progress * animationDuration;
    });
  };

  const scheduleProgressUpdate = () => {
    if (frameRequest) return;
    frameRequest = window.requestAnimationFrame(updateProgress);
  };

  section.classList.remove("is-motion-complete");
  section.classList.add("is-sparkle-active");

  window.requestAnimationFrame(() => {
    animations = sparkles.flatMap((sparkle) => sparkle.getAnimations());
    if (animations.length === 0) {
      section.classList.remove("is-sparkle-active");
      section.classList.add("is-motion-complete");
      return;
    }

    animations.forEach((animation) => {
      animation.pause();
      animation.currentTime = 0;
    });
    updateProgress();
  });

  window.addEventListener("scroll", scheduleProgressUpdate, { passive: true });
  window.addEventListener("resize", scheduleProgressUpdate, { passive: true });
}

export function initRevealAnimations() {
  const prizes = revealOnce(".sorteo-preview", "[data-prize-card]", ".prize-stage");
  initPrizeSparkleMotion(prizes);
  revealOnce(".participation", "[data-participation-card]", ".participation__steps");
  revealOnce(".faq", ".faq__sleigh", ".faq__intro");
  revealOnce(".discover", "[data-discover-card]", ".discover__products");
}

export function initVillancicosRevealAnimation(section = document) {
  const wrapper = section.querySelector(".villancicos__wrapper");
  if (!wrapper || wrapper.classList.contains("is-motion-ready")) return null;

  if (!("IntersectionObserver" in window)) {
    wrapper.classList.add("is-visible");
    return wrapper;
  }

  wrapper.classList.add("is-motion-ready");
  const observer = new IntersectionObserver(
    (entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      wrapper.classList.add("is-visible");
      observer.unobserve(wrapper);
    },
    { threshold: [REVEAL_THRESHOLD] },
  );
  observer.observe(wrapper);
  return wrapper;
}

export function initWinnerRevealAnimations() {
  revealOnce(".winner-results__grand-prize");
  revealOnce(".winner-results__list", "li:not([hidden])");
  revealOnce(".winner-claim__steps", "li");
}
